import type { FunctionComponent } from 'react';
import type { InjectedRouter } from 'react-router';

import { FileType } from '../../../../shared/fileUpload';

import UploadComponentPage from './UploadComponentPage';

type ArchiveUploadPageProps = {
  router: InjectedRouter;
};

const ArchiveUploadPage: FunctionComponent<ArchiveUploadPageProps> = ({
  router,
}) => {
  return (
    <UploadComponentPage
      router={router}
      fileType={FileType.Archive}
    />
  );
};

export default ArchiveUploadPage;
